module.exports = __webpack_public_path__ + "img/大廳.d489b935.jpg";